/** Shared Tanzania region options (slug values used across registrations). */
export const TANZANIA_REGION_OPTIONS = [
  { value: 'arusha', label: 'Arusha' },
  { value: 'dar-es-salaam', label: 'Dar es Salaam' },
  { value: 'dodoma', label: 'Dodoma' },
  { value: 'geita', label: 'Geita' },
  { value: 'iringa', label: 'Iringa' },
  { value: 'kagera', label: 'Kagera' },
  { value: 'katavi', label: 'Katavi' },
  { value: 'kigoma', label: 'Kigoma' },
  { value: 'kilimanjaro', label: 'Kilimanjaro' },
  { value: 'lindi', label: 'Lindi' },
  { value: 'manyara', label: 'Manyara' },
  { value: 'mara', label: 'Mara' },
  { value: 'mbeya', label: 'Mbeya' },
  { value: 'morogoro', label: 'Morogoro' },
  { value: 'mtwara', label: 'Mtwara' },
  { value: 'mwanza', label: 'Mwanza' },
  { value: 'njombe', label: 'Njombe' },
  { value: 'pemba-north', label: 'Pemba North' },
  { value: 'pemba-south', label: 'Pemba South' },
  { value: 'pwani', label: 'Pwani' },
  { value: 'rukwa', label: 'Rukwa' },
  { value: 'ruvuma', label: 'Ruvuma' },
  { value: 'shinyanga', label: 'Shinyanga' },
  { value: 'simiyu', label: 'Simiyu' },
  { value: 'singida', label: 'Singida' },
  { value: 'songwe', label: 'Songwe' },
  { value: 'tabora', label: 'Tabora' },
  { value: 'tanga', label: 'Tanga' },
  { value: 'unguja-north', label: 'Unguja North' },
  { value: 'unguja-south', label: 'Unguja South' },
  { value: 'unguja-urban-west', label: 'Unguja Urban/West' },
];

export const getRegionLabel = (value) =>
  TANZANIA_REGION_OPTIONS.find((option) => option.value === value)?.label || value || '—';

export const isRegionAdmin = (role) => role === 'region_admin';
